import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';

export const share = t => {
  trackEvent('Shared', 'User clicked on share');
  if (navigator.share) {
    navigator
      .share({
        title: t('reporting.share.subject'),
        url: 'https://covidspare.com',
      })
      .then(() => {
        console.log('Shared!');
      })
      .catch(console.error);
  } else {
    window.open(
      `mailto:?subject=${t('reporting.share.subject')}&body=${t(
        'reporting.share.body'
      )}`,
      '_blank'
    );
  }
};
